import { Navigate, Route, Routes } from 'react-router-dom'
import { LoginContainer } from '../containers/login/LoginContainer'
import { ROUTE_LIST } from 'routes/route-list'
import { isLogin } from 'utils/utils'
import { UserListContainer } from '../containers/user/user-list/UserListContainer'
import { PrivateRoute } from 'routes/private-route'
import { ForgotPasswordContainer } from '../containers/forgot-password/ForgotPasswordContainer'
import { useSelector } from 'react-redux'
import { UnderMaintenanceContainer } from '../containers/under-maintenance/UnderMaintenanceContainer'

export default function RoutePage() {
    const { sidebarList } = useSelector((state) => state.homeReducer)

    const getDefaultRoute = () => {
        return ROUTE_LIST?.find((item) => item?.path === `/${sidebarList[0]?.key}/${sidebarList[0]?.children[0]?.key}`)
    }

    return (
        <Routes>
            <Route path='/' element={isLogin() ? getDefaultRoute()?.component : <LoginContainer />} />
            <Route path='/forgot-password' element={isLogin() ? <UserListContainer /> : <ForgotPasswordContainer />} />
            <Route path='/under-maintenance' element={<UnderMaintenanceContainer />} />
            {ROUTE_LIST.map((item, index) => (
                <Route key={index.toString()} path={item.path} element={<PrivateRoute children={item.component} />} />
            ))}
            <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
    )
}
